import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgramsFacade } from '@app/programs/views/services/programs.facade';
import { ActivatedRoute } from '@angular/router';
import { filter, first, map } from 'rxjs/operators';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'app-program-terms',
  templateUrl: './program-terms.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    SharedModule,
  ],
})
export class ProgramTermsComponent implements OnInit {
  protected readonly program$ = this.programsFacade.program$;
  protected readonly error$ = this.programsFacade.error$;

  constructor(private programsFacade: ProgramsFacade,
              private route: ActivatedRoute) {}

  public ngOnInit(): void {
    this.route.paramMap.pipe(
      map(param => param.get('id')),
      filter(Boolean),
      first(),
    ).subscribe(id =>
      this.programsFacade.loadProgram(+id),
    );

  }
}
